import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {MenuItem} from '../../shared/models/menu-item';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  private menuItemMapper: BehaviorSubject<(items: MenuItem[]) => MenuItem[]> = new BehaviorSubject(items => items);

  constructor() {
  }

  getItemMapper(): Observable<(items: MenuItem[]) => MenuItem[]> {
    return this.menuItemMapper.asObservable();
  }

  setItemMapper(value: (items: MenuItem[]) => MenuItem[]) {
    this.menuItemMapper.next(value);
  }

  reset() {
    this.menuItemMapper.next(items => items);
  }
}
